import React, { useState, useEffect, useRef, useMemo } from "react";

import CommonCard from "../../../../Components/common/CommonCard";
import TableFilters from "../../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../../Components/common/TableGrid/TableTabs";
import TableGrid from "../../../../Components/common/TableGrid";
import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg"
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';
import { useGetCargoDamageForwardersQuery } from '../../../../redux/services/SPL';
import { onTabChange, clearSelectedRowsData } from '../../../../redux/features/table/tableSlice';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as EyeIcon } from "../../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { CallApi } from "../../../../Components/common/CommonFunctions";
import { toast } from "react-toastify";
import TripModal from "../common/TripModal";
import { withRFSToken } from "../../../../Services/axios";
import ConfModal from "../../../../Components/common/ConfModal";
const TripView = () => {
    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
    const dispatch = useDispatch(); 
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const station = JSON.parse(localStorage.getItem("Handler_stn"))?.station_name;
    const isMounted = useRef(false);
    const iconMap = { tripstoday, onpremises, inprogress, arriving, };
    const [warehouse, setWarehouse] = useState([]);
    const [org, setOrg] = useState([]);
    const [sendData, setSendData] = useState({});
    const [showModal, setShowModal] = useState(false);

    const fetchWarehousOrgnaziation = async () => {
        CallApi({
            endPoint: `trip-management/slot-warehouse-organizations`, 
            method: 'get',
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                setOrg(innerData?.organization);
                setWarehouse(innerData?.warehouses);
            },
            onError: (msg) => toast.error(msg)
        });
    };
    useEffect(() => {
        if (isMounted.current) return;
        fetchWarehousOrgnaziation();
        dispatch(onTabChange({ key: 'tab', value: "A" }));
        isMounted.current = true;
    }, []);
    const filtersConfig = [
        {
            type: "input",
            field: "truck_nos",
            placeholder: "Search Truck No.",
        },
        {
            type: "multiselect",
            field: "warehouse",
            placeholder: "Warehouse",
            options: warehouse?.map((item) => ({
                label: item.name,
                value: item.id,
            })) || [],
        },
        {
            type: "multiselect",
            field: "org_id",
            placeholder: "Organization",
            options: org?.map((item) => ({
                label: item.org_Name,
                value: item.org_Key,
            })) || [],
        },
        {
            type: "multiselect",
            field: "operation",
            placeholder: "Operation",
            options: [{ label: "Loading", value: "loading" },
            { label: "Unloading", value: "unloading" }]
        },
    ];
    const tabsConfig = [
        // { label: "All", value: "all", paramKey: null },
        { label: "Open", value: "A", paramKey: "tab" },
        { label: "Archive", value: "R", paramKey: "tab" },
    ];
  const buildFilterParams = (filtersObj) => {
        const entries = Object.entries(filtersObj);
        const params = {};

        if (!entries.length) return params;

        entries.forEach(([field, value], index) => {
            params[`filtervalue${index}`] = value;
            params[`filtercondition${index}`] = "CONTAINS";
            params[`filteroperator${index}`] = 0;
            params[`filterdatafield${index}`] = field;
        });

        params.filterscount = entries.length;

        return params;
    };

    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);

        const params = {
            ...filterParams,
            type: 'trip_view',
            station: station,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
            recordstartindex: pageDetails.recordstartindex,
            recordendindex: pageDetails.recordendindex,
        };

        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }

        if (tab?.value && tab.value !== "all" && tab.key) {
            params[tab.key] = tab.value;
        }
        return params;
    }, [filters, pageDetails, sortby]);

    const { data: myData, isFetching, refetch } = useGetCargoDamageForwardersQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
        pollingInterval: 900000,
    });
    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'single_action',
            renderCell: (row) => (<div className="tb_grid_actions">
                <EyeIcon className="row_view" style={{ cursor: "pointer" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        loadDetails(row.id, "V");
                    }}
                />
            </div>),
        },
        { label: "Truck No", field: "truck_nos", enableSearch: false, cls: 'tw-8', },
        {
            label: "Organization", field: "vehicle_no", enableSearch: false, cls: 'tw-8',
            renderCell: (row) => {
                const organization_name = row?.org_name;
                return (<span>{organization_name}</span>);
            },
        },

        {
      label: "Status", field: "status_type", enableSearch: false, cls: 'tw-7',
      renderCell: (row) => {
        const status = row.status_type;
        return (
          <div className={`status ${status === "Open" ? "bg-gry" : status === "Completed" ? "bgc-grn" : "bgc-org"}`}>
            <span className="stat-txt">{status}</span>
          </div>
        );
      },
    },
        // {
        //   label: "Gate In", field: "gate_in", enableSearch: false, cls: 'tw-6',
        //   renderCell: (row) => (
        //     !row?.gate_in ? (
        //       <button className="edit_btn" onClick={() => { modalGateInOpen(row) }}>
        //         Gate In
        //       </button>
        //     ) : (
        //       <span>{row.gate_in}</span>
        //     )
        //   )
        // },
        {
            label: "Operation", field: "org_name", enableSearch: false, cls: 'tw-7',
            renderCell: (row) => {
                let operation;
                if (row?.shipping_type == 'L') { operation = "Loading" } else if (row?.shipping_type == 'U') { operation = "Unloading" }
                return (<span>{operation}</span>);
            },
        },
        { label: "Flow", field: "trip_status", enableSearch: false, cls: 'tw-7' },
        { label: "Planned Time", field: "planned_date_time", enableSearch: false, cls: 'tw-8' },
        { label: "Timeslot", field: "timeslot", enableSearch: false, cls: 'tw-7'},
        { label: "Door", field: "door_no", enableSearch: false, cls: 'tw-4' },
        { label: "Warehouse", field: "warehouse_name", enableSearch: false},
        // checkbox col takes remaining ~3% automatically via the fixed <th> in Table
    ];
     const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => {
        let timeslot = "";
        if (item?.slot_start_time && item?.slot_end_time) {
          const [, startTimeFull] = item.slot_start_time.split(" ");
          const [, endTimeFull] = item.slot_end_time.split(" ");
          const startTime = startTimeFull.slice(0, 5);
          const endTime = endTimeFull.slice(0, 5);
          timeslot = `${startTime} - ${endTime}`;
        }
        return {
          ...item,
          planned_date_time: item.planned_date_time
            ? item.planned_date_time.slice(0, 16)
            : "",
          timeslot,
        };
      }) || []
    );
  }, [myData]);
    const cards = [
        { icon: 'tripstoday', title: 'RFS - Trips Today', value: myData?.tripsToday },
        { icon: 'onpremises', title: 'RFS - On Premises', value: '0' },
        { icon: 'inprogress', title: 'RFS - In Progress', value: '0' },
        { icon: 'arriving', title: 'RFS - Arriving (Next 2h)', value: myData?.nextTwoHours },
    ];

    const loadDetails = (id, pos) => {
        setSendData({ id: id, ps: pos })
        setShowModal(true)
    }
     const handleMoveToActArc = () => {
          const isActiveTab = tab?.value === 'A';
          setConfData({
            header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
            subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
            primaryBtn: 'Confirm',
            secondaryBtn: 'Cancel',
            modalConf: tabChangeConf,
          });
          setModalConf(true);
        };
        const tabChangeConf = async () => {
          const isActiveTab = tab?.value === 'A';
          const payload = {
            type: 'trip_view',
            ids: selectedRows.map(row => row.id),
            status: isActiveTab ? 0 : 1, 
          };
          try {
            const res = await withRFSToken.post('trip-management/toggle-slot-status',payload);
            if (res.data.response_code === 200) {
              setModalConf(false);
              refetch();
              dispatch(clearSelectedRowsData());
            } else {
              toast.error(res.data.response_msg);
            }
          } catch (error) {
            console.error('Error updating status:', error);
            toast.error('Something went wrong');
          }
        };
        const confModalClose = () => {
        setModalConf(false);
        }

     const bulkActions = tab?.value === "A"
      ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
      : tab?.value === "R"
        ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
        : [];

    return (
        <>
            {showModal &&
                <TripModal propData={sendData} show={showModal} onHide={() => setShowModal(false)} />
            }
             {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            <div className="main-content">
                {cards?.length ?
                    <div className="card-bx">
                        {cards?.map((item, index) => (
                            <React.Fragment key={`crd_${index}`}>
                                <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
                            </React.Fragment>
                        ))}
                    </div>
                    : <></>
                }
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <TableFilters filtersConfig={filtersConfig} />
                    <TableTabs tabs={tabsConfig} />
                </div>
                <div>
                    <TableGrid
                        columns={columns}
                        rows={transformedRows}
                        checkboxSelection={true}
                        totalRecords={myData?.TotalRows || 0}
                        //  onClickRow={(row) => {
                        //    console.log("Clicked Row:", row);
                        //  }}
                        loading={isFetching}
                        bulkActions={bulkActions}
                        rowKey="id"
                    />
                </div>
            </div>
        </>
    )
}

export default TripView